var map = {
	"./css/_variaveis.scss": "./static/css/_variaveis.scss",
	"./css/animations.css": "./static/css/animations.css",
	"./css/general.css": "./static/css/general.css",
	"./css/onlyNecessaryBootstrap/bootstrap.css": "./static/css/onlyNecessaryBootstrap/bootstrap.css",
	"./css/tokens-semanticos.css": "./static/css/tokens-semanticos.css",
	"./css/transitions.css": "./static/css/transitions.css",
	"./css/variables.css": "./static/css/variables.css",
	"./fonts/Frutiger.otf": "./static/fonts/Frutiger.otf",
	"./fonts/HankenGrotesk-Italic-VariableFont_wght.ttf": "./static/fonts/HankenGrotesk-Italic-VariableFont_wght.ttf",
	"./fonts/HankenGrotesk-VariableFont_wght.ttf": "./static/fonts/HankenGrotesk-VariableFont_wght.ttf",
	"./fonts/MyriadPro-Bold.otf": "./static/fonts/MyriadPro-Bold.otf",
	"./fonts/MyriadPro-Light.otf": "./static/fonts/MyriadPro-Light.otf",
	"./fonts/Roboto/Roboto-Italic-VariableFont_wdth,wght.ttf": "./static/fonts/Roboto/Roboto-Italic-VariableFont_wdth,wght.ttf",
	"./fonts/Roboto/Roboto-VariableFont_wdth,wght.ttf": "./static/fonts/Roboto/Roboto-VariableFont_wdth,wght.ttf",
	"./fonts/Roboto/static/Roboto-Black.ttf": "./static/fonts/Roboto/static/Roboto-Black.ttf",
	"./fonts/Roboto/static/Roboto-BlackItalic.ttf": "./static/fonts/Roboto/static/Roboto-BlackItalic.ttf",
	"./fonts/Roboto/static/Roboto-Bold.ttf": "./static/fonts/Roboto/static/Roboto-Bold.ttf",
	"./fonts/Roboto/static/Roboto-BoldItalic.ttf": "./static/fonts/Roboto/static/Roboto-BoldItalic.ttf",
	"./fonts/Roboto/static/Roboto-ExtraBold.ttf": "./static/fonts/Roboto/static/Roboto-ExtraBold.ttf",
	"./fonts/Roboto/static/Roboto-ExtraBoldItalic.ttf": "./static/fonts/Roboto/static/Roboto-ExtraBoldItalic.ttf",
	"./fonts/Roboto/static/Roboto-ExtraLight.ttf": "./static/fonts/Roboto/static/Roboto-ExtraLight.ttf",
	"./fonts/Roboto/static/Roboto-ExtraLightItalic.ttf": "./static/fonts/Roboto/static/Roboto-ExtraLightItalic.ttf",
	"./fonts/Roboto/static/Roboto-Italic.ttf": "./static/fonts/Roboto/static/Roboto-Italic.ttf",
	"./fonts/Roboto/static/Roboto-Light.ttf": "./static/fonts/Roboto/static/Roboto-Light.ttf",
	"./fonts/Roboto/static/Roboto-LightItalic.ttf": "./static/fonts/Roboto/static/Roboto-LightItalic.ttf",
	"./fonts/Roboto/static/Roboto-Medium.ttf": "./static/fonts/Roboto/static/Roboto-Medium.ttf",
	"./fonts/Roboto/static/Roboto-MediumItalic.ttf": "./static/fonts/Roboto/static/Roboto-MediumItalic.ttf",
	"./fonts/Roboto/static/Roboto-Regular.ttf": "./static/fonts/Roboto/static/Roboto-Regular.ttf",
	"./fonts/Roboto/static/Roboto-SemiBold.ttf": "./static/fonts/Roboto/static/Roboto-SemiBold.ttf",
	"./fonts/Roboto/static/Roboto-SemiBoldItalic.ttf": "./static/fonts/Roboto/static/Roboto-SemiBoldItalic.ttf",
	"./fonts/Roboto/static/Roboto-Thin.ttf": "./static/fonts/Roboto/static/Roboto-Thin.ttf",
	"./fonts/Roboto/static/Roboto-ThinItalic.ttf": "./static/fonts/Roboto/static/Roboto-ThinItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-Black.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-Black.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-BlackItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-BlackItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-Bold.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-Bold.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-BoldItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-BoldItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-ExtraBold.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-ExtraBold.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-ExtraBoldItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-ExtraBoldItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-ExtraLight.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-ExtraLight.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-ExtraLightItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-ExtraLightItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-Italic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-Italic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-Light.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-Light.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-LightItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-LightItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-Medium.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-Medium.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-MediumItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-MediumItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-Regular.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-Regular.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-SemiBold.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-SemiBold.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-SemiBoldItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-SemiBoldItalic.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-Thin.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-Thin.ttf",
	"./fonts/Roboto/static/Roboto_Condensed-ThinItalic.ttf": "./static/fonts/Roboto/static/Roboto_Condensed-ThinItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-Black.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-Black.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-BlackItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-BlackItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-Bold.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-Bold.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-BoldItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-BoldItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-ExtraBold.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-ExtraBold.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-ExtraBoldItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-ExtraBoldItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-ExtraLight.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-ExtraLight.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-ExtraLightItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-ExtraLightItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-Italic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-Italic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-Light.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-Light.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-LightItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-LightItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-Medium.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-Medium.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-MediumItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-MediumItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-Regular.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-Regular.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-SemiBold.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-SemiBold.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-SemiBoldItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-SemiBoldItalic.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-Thin.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-Thin.ttf",
	"./fonts/Roboto/static/Roboto_SemiCondensed-ThinItalic.ttf": "./static/fonts/Roboto/static/Roboto_SemiCondensed-ThinItalic.ttf",
	"./fonts/Rubik.ttf": "./static/fonts/Rubik.ttf",
	"./icones/afastamento": "./static/icones/afastamento.svg",
	"./icones/afastamento.svg": "./static/icones/afastamento.svg",
	"./icones/alerta": "./static/icones/alerta.svg",
	"./icones/alerta.svg": "./static/icones/alerta.svg",
	"./icones/ativo": "./static/icones/ativo.svg",
	"./icones/ativo.svg": "./static/icones/ativo.svg",
	"./icones/avatar": "./static/icones/avatar.svg",
	"./icones/avatar-login": "./static/icones/avatar-login.svg",
	"./icones/avatar-login.svg": "./static/icones/avatar-login.svg",
	"./icones/avatar.svg": "./static/icones/avatar.svg",
	"./icones/aviao": "./static/icones/aviao.svg",
	"./icones/aviao.svg": "./static/icones/aviao.svg",
	"./icones/aviso": "./static/icones/aviso.svg",
	"./icones/aviso.svg": "./static/icones/aviso.svg",
	"./icones/bi-bank2": "./static/icones/bi-bank2.svg",
	"./icones/bi-bank2.svg": "./static/icones/bi-bank2.svg",
	"./icones/bi-receipt": "./static/icones/bi-receipt.svg",
	"./icones/bi-receipt.svg": "./static/icones/bi-receipt.svg",
	"./icones/bv-logo-5cd49411d28021000c09e013": "./static/icones/bv-logo-5cd49411d28021000c09e013.svg",
	"./icones/bv-logo-5cd49411d28021000c09e013.svg": "./static/icones/bv-logo-5cd49411d28021000c09e013.svg",
	"./icones/cadeado": "./static/icones/cadeado.svg",
	"./icones/cadeado.svg": "./static/icones/cadeado.svg",
	"./icones/caixaVazia": "./static/icones/caixaVazia.svg",
	"./icones/caixaVazia.svg": "./static/icones/caixaVazia.svg",
	"./icones/calendario": "./static/icones/calendario.svg",
	"./icones/calendario-nenhum-dia": "./static/icones/calendario-nenhum-dia.svg",
	"./icones/calendario-nenhum-dia.svg": "./static/icones/calendario-nenhum-dia.svg",
	"./icones/calendario.svg": "./static/icones/calendario.svg",
	"./icones/cancelado": "./static/icones/cancelado.svg",
	"./icones/cancelado.svg": "./static/icones/cancelado.svg",
	"./icones/celular": "./static/icones/celular.svg",
	"./icones/celular.svg": "./static/icones/celular.svg",
	"./icones/certo": "./static/icones/certo.svg",
	"./icones/certo.svg": "./static/icones/certo.svg",
	"./icones/chapado.css": "./static/icones/chapado.css",
	"./icones/chave": "./static/icones/chave.svg",
	"./icones/chave.svg": "./static/icones/chave.svg",
	"./icones/comprimir": "./static/icones/comprimir.svg",
	"./icones/comprimir.svg": "./static/icones/comprimir.svg",
	"./icones/dispensa": "./static/icones/dispensa.svg",
	"./icones/dispensa.svg": "./static/icones/dispensa.svg",
	"./icones/documento": "./static/icones/documento.svg",
	"./icones/documento-download": "./static/icones/documento-download.svg",
	"./icones/documento-download.svg": "./static/icones/documento-download.svg",
	"./icones/documento.svg": "./static/icones/documento.svg",
	"./icones/download": "./static/icones/download.svg",
	"./icones/download.svg": "./static/icones/download.svg",
	"./icones/emojiTriste": "./static/icones/emojiTriste.svg",
	"./icones/emojiTriste.svg": "./static/icones/emojiTriste.svg",
	"./icones/empresa-white-label-logo-5cd49411d28021000c09e013": "./static/icones/empresa-white-label-logo-5cd49411d28021000c09e013.svg",
	"./icones/empresa-white-label-logo-5cd49411d28021000c09e013.svg": "./static/icones/empresa-white-label-logo-5cd49411d28021000c09e013.svg",
	"./icones/entrar": "./static/icones/entrar.svg",
	"./icones/entrar.svg": "./static/icones/entrar.svg",
	"./icones/errado": "./static/icones/errado.svg",
	"./icones/errado.svg": "./static/icones/errado.svg",
	"./icones/erro": "./static/icones/erro.svg",
	"./icones/erro-preenchido": "./static/icones/erro-preenchido.svg",
	"./icones/erro-preenchido.svg": "./static/icones/erro-preenchido.svg",
	"./icones/erro.svg": "./static/icones/erro.svg",
	"./icones/erro_informacao": "./static/icones/erro_informacao.svg",
	"./icones/erro_informacao.svg": "./static/icones/erro_informacao.svg",
	"./icones/erro_linha_sem_borda": "./static/icones/erro_linha_sem_borda.svg",
	"./icones/erro_linha_sem_borda.svg": "./static/icones/erro_linha_sem_borda.svg",
	"./icones/facebook": "./static/icones/facebook.svg",
	"./icones/facebook.svg": "./static/icones/facebook.svg",
	"./icones/falhou": "./static/icones/falhou.svg",
	"./icones/falhou.svg": "./static/icones/falhou.svg",
	"./icones/feriado": "./static/icones/feriado.svg",
	"./icones/feriado.svg": "./static/icones/feriado.svg",
	"./icones/ferias": "./static/icones/ferias.svg",
	"./icones/ferias.svg": "./static/icones/ferias.svg",
	"./icones/folga": "./static/icones/folga.svg",
	"./icones/folga.svg": "./static/icones/folga.svg",
	"./icones/folha": "./static/icones/folha.svg",
	"./icones/folha.svg": "./static/icones/folha.svg",
	"./icones/grafico": "./static/icones/grafico.svg",
	"./icones/grafico-chapado": "./static/icones/grafico-chapado.svg",
	"./icones/grafico-chapado.svg": "./static/icones/grafico-chapado.svg",
	"./icones/grafico.svg": "./static/icones/grafico.svg",
	"./icones/historico": "./static/icones/historico.svg",
	"./icones/historico.svg": "./static/icones/historico.svg",
	"./icones/horas_extras": "./static/icones/horas_extras.svg",
	"./icones/horas_extras.svg": "./static/icones/horas_extras.svg",
	"./icones/icone-alterar": "./static/icones/icone-alterar.svg",
	"./icones/icone-alterar.svg": "./static/icones/icone-alterar.svg",
	"./icones/icone-biometria-facial": "./static/icones/icone-biometria-facial.svg",
	"./icones/icone-biometria-facial.svg": "./static/icones/icone-biometria-facial.svg",
	"./icones/icone-borda": "./static/icones/icone-borda.svg",
	"./icones/icone-borda.svg": "./static/icones/icone-borda.svg",
	"./icones/icone-camera-proibido": "./static/icones/icone-camera-proibido.svg",
	"./icones/icone-camera-proibido.svg": "./static/icones/icone-camera-proibido.svg",
	"./icones/icone-celebrar-pontotel": "./static/icones/icone-celebrar-pontotel.svg",
	"./icones/icone-celebrar-pontotel-inline": "./static/icones/icone-celebrar-pontotel-inline.svg",
	"./icones/icone-celebrar-pontotel-inline.svg": "./static/icones/icone-celebrar-pontotel-inline.svg",
	"./icones/icone-celebrar-pontotel.svg": "./static/icones/icone-celebrar-pontotel.svg",
	"./icones/icone-email": "./static/icones/icone-email.svg",
	"./icones/icone-email.svg": "./static/icones/icone-email.svg",
	"./icones/icone-fechar": "./static/icones/icone-fechar.svg",
	"./icones/icone-fechar.svg": "./static/icones/icone-fechar.svg",
	"./icones/icone-humano": "./static/icones/icone-humano.svg",
	"./icones/icone-humano-linha": "./static/icones/icone-humano-linha.svg",
	"./icones/icone-humano-linha.svg": "./static/icones/icone-humano-linha.svg",
	"./icones/icone-humano-quadrado": "./static/icones/icone-humano-quadrado.svg",
	"./icones/icone-humano-quadrado.svg": "./static/icones/icone-humano-quadrado.svg",
	"./icones/icone-humano.svg": "./static/icones/icone-humano.svg",
	"./icones/icone-interrogacao": "./static/icones/icone-interrogacao.svg",
	"./icones/icone-interrogacao.svg": "./static/icones/icone-interrogacao.svg",
	"./icones/icone-lupa-preenchido": "./static/icones/icone-lupa-preenchido.svg",
	"./icones/icone-lupa-preenchido.svg": "./static/icones/icone-lupa-preenchido.svg",
	"./icones/icone-mapa-enquadrar": "./static/icones/icone-mapa-enquadrar.svg",
	"./icones/icone-mapa-enquadrar.svg": "./static/icones/icone-mapa-enquadrar.svg",
	"./icones/icone-mapa-mais": "./static/icones/icone-mapa-mais.svg",
	"./icones/icone-mapa-mais.svg": "./static/icones/icone-mapa-mais.svg",
	"./icones/icone-mapa-marcador": "./static/icones/icone-mapa-marcador.svg",
	"./icones/icone-mapa-marcador.svg": "./static/icones/icone-mapa-marcador.svg",
	"./icones/icone-mapa-menos": "./static/icones/icone-mapa-menos.svg",
	"./icones/icone-mapa-menos.svg": "./static/icones/icone-mapa-menos.svg",
	"./icones/icone-seta-esquerda": "./static/icones/icone-seta-esquerda.svg",
	"./icones/icone-seta-esquerda.svg": "./static/icones/icone-seta-esquerda.svg",
	"./icones/icone-seta-redirecionamento": "./static/icones/icone-seta-redirecionamento.svg",
	"./icones/icone-seta-redirecionamento.svg": "./static/icones/icone-seta-redirecionamento.svg",
	"./icones/icone-setas-circulares": "./static/icones/icone-setas-circulares.svg",
	"./icones/icone-setas-circulares.svg": "./static/icones/icone-setas-circulares.svg",
	"./icones/icone-trabalho": "./static/icones/icone-trabalho.svg",
	"./icones/icone-trabalho.svg": "./static/icones/icone-trabalho.svg",
	"./icones/icone-usuario-retrato": "./static/icones/icone-usuario-retrato.svg",
	"./icones/icone-usuario-retrato.svg": "./static/icones/icone-usuario-retrato.svg",
	"./icones/icone_draggable": "./static/icones/icone_draggable.svg",
	"./icones/icone_draggable.svg": "./static/icones/icone_draggable.svg",
	"./icones/icone_lista": "./static/icones/icone_lista.svg",
	"./icones/icone_lista.svg": "./static/icones/icone_lista.svg",
	"./icones/icone_pizza": "./static/icones/icone_pizza.svg",
	"./icones/icone_pizza.svg": "./static/icones/icone_pizza.svg",
	"./icones/icone_trabalhando": "./static/icones/icone_trabalhando.svg",
	"./icones/icone_trabalhando.svg": "./static/icones/icone_trabalhando.svg",
	"./icones/identificador-chevron": "./static/icones/identificador-chevron.svg",
	"./icones/identificador-chevron.svg": "./static/icones/identificador-chevron.svg",
	"./icones/inativo": "./static/icones/inativo.svg",
	"./icones/inativo.svg": "./static/icones/inativo.svg",
	"./icones/indicar": "./static/icones/indicar.svg",
	"./icones/indicar.svg": "./static/icones/indicar.svg",
	"./icones/informativo": "./static/icones/informativo.svg",
	"./icones/informativo.svg": "./static/icones/informativo.svg",
	"./icones/instagram": "./static/icones/instagram.svg",
	"./icones/instagram.svg": "./static/icones/instagram.svg",
	"./icones/inteligencia-artificial": "./static/icones/inteligencia-artificial.svg",
	"./icones/inteligencia-artificial.svg": "./static/icones/inteligencia-artificial.svg",
	"./icones/joinha": "./static/icones/joinha.svg",
	"./icones/joinha.svg": "./static/icones/joinha.svg",
	"./icones/lapis": "./static/icones/lapis.svg",
	"./icones/lapis.svg": "./static/icones/lapis.svg",
	"./icones/linha.css": "./static/icones/linha.css",
	"./icones/linkedin": "./static/icones/linkedin.svg",
	"./icones/linkedin.svg": "./static/icones/linkedin.svg",
	"./icones/loading-setas": "./static/icones/loading-setas.svg",
	"./icones/loading-setas.svg": "./static/icones/loading-setas.svg",
	"./icones/logo-mindsight": "./static/icones/logo-mindsight.svg",
	"./icones/logo-mindsight.svg": "./static/icones/logo-mindsight.svg",
	"./icones/logo-sankhya": "./static/icones/logo-sankhya.svg",
	"./icones/logo-sankhya.svg": "./static/icones/logo-sankhya.svg",
	"./icones/lupa": "./static/icones/lupa.svg",
	"./icones/lupa.svg": "./static/icones/lupa.svg",
	"./icones/mao_pendente": "./static/icones/mao_pendente.svg",
	"./icones/mao_pendente.svg": "./static/icones/mao_pendente.svg",
	"./icones/mao_pendente_linha": "./static/icones/mao_pendente_linha.svg",
	"./icones/mao_pendente_linha.svg": "./static/icones/mao_pendente_linha.svg",
	"./icones/megafone": "./static/icones/megafone.svg",
	"./icones/megafone.svg": "./static/icones/megafone.svg",
	"./icones/ocultar": "./static/icones/ocultar.svg",
	"./icones/ocultar.svg": "./static/icones/ocultar.svg",
	"./icones/pendente": "./static/icones/pendente.svg",
	"./icones/pendente.svg": "./static/icones/pendente.svg",
	"./icones/pendente_justificativa": "./static/icones/pendente_justificativa.svg",
	"./icones/pendente_justificativa.svg": "./static/icones/pendente_justificativa.svg",
	"./icones/pendente_justificativa_linha": "./static/icones/pendente_justificativa_linha.svg",
	"./icones/pendente_justificativa_linha.svg": "./static/icones/pendente_justificativa_linha.svg",
	"./icones/pessoinha": "./static/icones/pessoinha.svg",
	"./icones/pessoinha.svg": "./static/icones/pessoinha.svg",
	"./icones/placar": "./static/icones/placar.svg",
	"./icones/placar.svg": "./static/icones/placar.svg",
	"./icones/planilha": "./static/icones/planilha.svg",
	"./icones/planilha.svg": "./static/icones/planilha.svg",
	"./icones/ponto-by-sankhya": "./static/icones/ponto-by-sankhya.png",
	"./icones/ponto-by-sankhya.png": "./static/icones/ponto-by-sankhya.png",
	"./icones/ponto-entrada": "./static/icones/ponto-entrada.svg",
	"./icones/ponto-entrada.svg": "./static/icones/ponto-entrada.svg",
	"./icones/ponto-pausa": "./static/icones/ponto-pausa.svg",
	"./icones/ponto-pausa.svg": "./static/icones/ponto-pausa.svg",
	"./icones/ponto-retorno": "./static/icones/ponto-retorno.svg",
	"./icones/ponto-retorno.svg": "./static/icones/ponto-retorno.svg",
	"./icones/ponto-saida": "./static/icones/ponto-saida.svg",
	"./icones/ponto-saida.svg": "./static/icones/ponto-saida.svg",
	"./icones/pontotel-marca": "./static/icones/pontotel-marca.svg",
	"./icones/pontotel-marca.svg": "./static/icones/pontotel-marca.svg",
	"./icones/pontotel-sankhya-logo": "./static/icones/pontotel-sankhya-logo.svg",
	"./icones/pontotel-sankhya-logo.svg": "./static/icones/pontotel-sankhya-logo.svg",
	"./icones/praia": "./static/icones/praia.svg",
	"./icones/praia.svg": "./static/icones/praia.svg",
	"./icones/relatorios-importacoes": "./static/icones/relatorios-importacoes.svg",
	"./icones/relatorios-importacoes.svg": "./static/icones/relatorios-importacoes.svg",
	"./icones/relogio": "./static/icones/relogio.svg",
	"./icones/relogio.svg": "./static/icones/relogio.svg",
	"./icones/reprovado": "./static/icones/reprovado.svg",
	"./icones/reprovado.svg": "./static/icones/reprovado.svg",
	"./icones/sem-anexo": "./static/icones/sem-anexo.svg",
	"./icones/sem-anexo.svg": "./static/icones/sem-anexo.svg",
	"./icones/sem-conexao": "./static/icones/sem-conexao.svg",
	"./icones/sem-conexao.svg": "./static/icones/sem-conexao.svg",
	"./icones/solicitacoes": "./static/icones/solicitacoes.svg",
	"./icones/solicitacoes.svg": "./static/icones/solicitacoes.svg",
	"./icones/sparkles": "./static/icones/sparkles.svg",
	"./icones/sparkles.svg": "./static/icones/sparkles.svg",
	"./icones/sucesso": "./static/icones/sucesso.svg",
	"./icones/sucesso-preenchido": "./static/icones/sucesso-preenchido.svg",
	"./icones/sucesso-preenchido.svg": "./static/icones/sucesso-preenchido.svg",
	"./icones/sucesso.svg": "./static/icones/sucesso.svg",
	"./icones/suspensao": "./static/icones/suspensao.svg",
	"./icones/suspensao.svg": "./static/icones/suspensao.svg",
	"./icones/tesoura": "./static/icones/tesoura.svg",
	"./icones/tesoura.svg": "./static/icones/tesoura.svg",
	"./icones/tiktok": "./static/icones/tiktok.svg",
	"./icones/tiktok.svg": "./static/icones/tiktok.svg",
	"./icones/tornar-visivel": "./static/icones/tornar-visivel.svg",
	"./icones/tornar-visivel.svg": "./static/icones/tornar-visivel.svg",
	"./icones/utilitarios.css": "./static/icones/utilitarios.css",
	"./icones/vencida_de_resposta": "./static/icones/vencida_de_resposta.svg",
	"./icones/vencida_de_resposta.svg": "./static/icones/vencida_de_resposta.svg",
	"./icones/vencida_justificativa_linha": "./static/icones/vencida_justificativa_linha.svg",
	"./icones/vencida_justificativa_linha.svg": "./static/icones/vencida_justificativa_linha.svg",
	"./icones/vencida_resposta_linha": "./static/icones/vencida_resposta_linha.svg",
	"./icones/vencida_resposta_linha.svg": "./static/icones/vencida_resposta_linha.svg",
	"./icones/verificado": "./static/icones/verificado.svg",
	"./icones/verificado-preenchido": "./static/icones/verificado-preenchido.svg",
	"./icones/verificado-preenchido.svg": "./static/icones/verificado-preenchido.svg",
	"./icones/verificado.svg": "./static/icones/verificado.svg",
	"./icones/webfonts/chapado": "./static/icones/webfonts/chapado.svg",
	"./icones/webfonts/chapado.eot": "./static/icones/webfonts/chapado.eot",
	"./icones/webfonts/chapado.svg": "./static/icones/webfonts/chapado.svg",
	"./icones/webfonts/chapado.ttf": "./static/icones/webfonts/chapado.ttf",
	"./icones/webfonts/chapado.woff": "./static/icones/webfonts/chapado.woff",
	"./icones/webfonts/linha": "./static/icones/webfonts/linha.svg",
	"./icones/webfonts/linha.eot": "./static/icones/webfonts/linha.eot",
	"./icones/webfonts/linha.svg": "./static/icones/webfonts/linha.svg",
	"./icones/webfonts/linha.ttf": "./static/icones/webfonts/linha.ttf",
	"./icones/webfonts/linha.woff": "./static/icones/webfonts/linha.woff",
	"./icones/whatsapp": "./static/icones/whatsapp.svg",
	"./icones/whatsapp.svg": "./static/icones/whatsapp.svg",
	"./icones/youtube": "./static/icones/youtube.svg",
	"./icones/youtube.svg": "./static/icones/youtube.svg",
	"./icons-antigo/fonts/icomoon": "./static/icons-antigo/fonts/icomoon.svg",
	"./icons-antigo/fonts/icomoon.eot": "./static/icons-antigo/fonts/icomoon.eot",
	"./icons-antigo/fonts/icomoon.svg": "./static/icons-antigo/fonts/icomoon.svg",
	"./icons-antigo/fonts/icomoon.ttf": "./static/icons-antigo/fonts/icomoon.ttf",
	"./icons-antigo/fonts/icomoon.woff": "./static/icons-antigo/fonts/icomoon.woff",
	"./icons-antigo/style.css": "./static/icons-antigo/style.css",
	"./images/abacaxildo-acesso-negado": "./static/images/abacaxildo-acesso-negado.png",
	"./images/abacaxildo-acesso-negado.png": "./static/images/abacaxildo-acesso-negado.png",
	"./images/acompanhamento-tempo-real": "./static/images/acompanhamento-tempo-real.png",
	"./images/acompanhamento-tempo-real.png": "./static/images/acompanhamento-tempo-real.png",
	"./images/arrow_down": "./static/images/arrow_down.svg",
	"./images/arrow_down.svg": "./static/images/arrow_down.svg",
	"./images/banner-gerenciamento-de-dispositivo": "./static/images/banner-gerenciamento-de-dispositivo.png",
	"./images/banner-gerenciamento-de-dispositivo.png": "./static/images/banner-gerenciamento-de-dispositivo.png",
	"./images/banner_app_suporte": "./static/images/banner_app_suporte.png",
	"./images/banner_app_suporte.png": "./static/images/banner_app_suporte.png",
	"./images/banner_novo_layout_solicitacoes": "./static/images/banner_novo_layout_solicitacoes.png",
	"./images/banner_novo_layout_solicitacoes.png": "./static/images/banner_novo_layout_solicitacoes.png",
	"./images/cognito-bg-inferior": "./static/images/cognito-bg-inferior.svg",
	"./images/cognito-bg-inferior.svg": "./static/images/cognito-bg-inferior.svg",
	"./images/cognito-bg-superior": "./static/images/cognito-bg-superior.svg",
	"./images/cognito-bg-superior.svg": "./static/images/cognito-bg-superior.svg",
	"./images/copy_content": "./static/images/copy_content.svg",
	"./images/copy_content.svg": "./static/images/copy_content.svg",
	"./images/date_picker_icon": "./static/images/date_picker_icon.svg",
	"./images/date_picker_icon.svg": "./static/images/date_picker_icon.svg",
	"./images/dentro-janela-limite": "./static/images/dentro-janela-limite.svg",
	"./images/dentro-janela-limite-15": "./static/images/dentro-janela-limite-15.svg",
	"./images/dentro-janela-limite-15.svg": "./static/images/dentro-janela-limite-15.svg",
	"./images/dentro-janela-limite-30": "./static/images/dentro-janela-limite-30.svg",
	"./images/dentro-janela-limite-30.svg": "./static/images/dentro-janela-limite-30.svg",
	"./images/dentro-janela-limite.svg": "./static/images/dentro-janela-limite.svg",
	"./images/erro_x": "./static/images/erro_x.svg",
	"./images/erro_x.svg": "./static/images/erro_x.svg",
	"./images/fora-janela-limite": "./static/images/fora-janela-limite.svg",
	"./images/fora-janela-limite.svg": "./static/images/fora-janela-limite.svg",
	"./images/fundo-site": "./static/images/fundo-site.jpg",
	"./images/fundo-site.jpg": "./static/images/fundo-site.jpg",
	"./images/header_admin": "./static/images/header_admin.svg",
	"./images/header_admin.svg": "./static/images/header_admin.svg",
	"./images/header_cadastros": "./static/images/header_cadastros.svg",
	"./images/header_cadastros.svg": "./static/images/header_cadastros.svg",
	"./images/header_folhas": "./static/images/header_folhas.svg",
	"./images/header_folhas.svg": "./static/images/header_folhas.svg",
	"./images/header_jornada": "./static/images/header_jornada.svg",
	"./images/header_jornada.svg": "./static/images/header_jornada.svg",
	"./images/header_sair": "./static/images/header_sair.svg",
	"./images/header_sair.svg": "./static/images/header_sair.svg",
	"./images/header_sino": "./static/images/header_sino.svg",
	"./images/header_sino.svg": "./static/images/header_sino.svg",
	"./images/header_user_avatar": "./static/images/header_user_avatar.svg",
	"./images/header_user_avatar.svg": "./static/images/header_user_avatar.svg",
	"./images/header_verificar": "./static/images/header_verificar.svg",
	"./images/header_verificar.svg": "./static/images/header_verificar.svg",
	"./images/home_duvidas": "./static/images/home_duvidas.svg",
	"./images/home_duvidas.svg": "./static/images/home_duvidas.svg",
	"./images/home_folha_de_pontos": "./static/images/home_folha_de_pontos.svg",
	"./images/home_folha_de_pontos.svg": "./static/images/home_folha_de_pontos.svg",
	"./images/home_funcionarios": "./static/images/home_funcionarios.svg",
	"./images/home_funcionarios.svg": "./static/images/home_funcionarios.svg",
	"./images/home_jornadas": "./static/images/home_jornadas.svg",
	"./images/home_jornadas.svg": "./static/images/home_jornadas.svg",
	"./images/home_locais_de_trabalho": "./static/images/home_locais_de_trabalho.svg",
	"./images/home_locais_de_trabalho.svg": "./static/images/home_locais_de_trabalho.svg",
	"./images/home_verificar_folha": "./static/images/home_verificar_folha.svg",
	"./images/home_verificar_folha.svg": "./static/images/home_verificar_folha.svg",
	"./images/loading": "./static/images/loading.svg",
	"./images/loading.svg": "./static/images/loading.svg",
	"./images/logo-colorido": "./static/images/logo-colorido.png",
	"./images/logo-colorido.png": "./static/images/logo-colorido.png",
	"./images/logo-mindsight": "./static/images/logo-mindsight.svg",
	"./images/logo-mindsight.svg": "./static/images/logo-mindsight.svg",
	"./images/logo-pontotel": "./static/images/logo-pontotel.png",
	"./images/logo-pontotel-branco": "./static/images/logo-pontotel-branco.png",
	"./images/logo-pontotel-branco.png": "./static/images/logo-pontotel-branco.png",
	"./images/logo-pontotel.png": "./static/images/logo-pontotel.png",
	"./images/logo-sankhya": "./static/images/logo-sankhya.svg",
	"./images/logo-sankhya-inputs": "./static/images/logo-sankhya-inputs.svg",
	"./images/logo-sankhya-inputs.svg": "./static/images/logo-sankhya-inputs.svg",
	"./images/logo-sankhya.svg": "./static/images/logo-sankhya.svg",
	"./images/logosankhya": "./static/images/logosankhya.svg",
	"./images/logosankhya.svg": "./static/images/logosankhya.svg",
	"./images/logovixting": "./static/images/logovixting.png",
	"./images/logovixting.png": "./static/images/logovixting.png",
	"./images/nina": "./static/images/nina.png",
	"./images/nina.png": "./static/images/nina.png",
	"./images/pessoinha": "./static/images/pessoinha.svg",
	"./images/pessoinha.svg": "./static/images/pessoinha.svg",
	"./js/es-co": "./static/js/es-co.js",
	"./js/es-co.js": "./static/js/es-co.js",
	"./js/pt-br": "./static/js/pt-br.js",
	"./js/pt-br.js": "./static/js/pt-br.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./static sync recursive ^\\.\\/.*$";